import produce from 'immer';

// TYPES
import { Types, ExcluirOrgao } from './types';
import { ReducerAction } from '../../../../../types';

export const INITIAL_STATE: ExcluirOrgao = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): ExcluirOrgao {
	return produce(state, draft => {
		switch (action.type) {
			case Types.EXCLUIR_ORGAO: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.EXCLUIR_ORGAO_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.EXCLUIR_ORGAO_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.EXCLUIR_ORGAO_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
	});
}
